import { render, staticRenderFns } from "./flowCustomerAct.vue?vue&type=template&id=0d7a065c&scoped=true"
import script from "./flowCustomerAct.vue?vue&type=script&lang=js"
export * from "./flowCustomerAct.vue?vue&type=script&lang=js"
import style0 from "./flowCustomerAct.vue?vue&type=style&index=0&id=0d7a065c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7a065c",
  null
  
)

export default component.exports